import React from 'react';
import AuthService from './authService.js';

class TaskService extends React.Component {
  static GetTaskList() {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction('/api/Task?clearCache=false');
  }

  static DeleteTask(task) {
    const authService = AuthService.getInstance();
    task.isActive = 0;
    return authService.CallBackendFunctionPut(`/api/Task/${task.taskId}`, this.ConvertTaskToJSON(task));
  }

  static SaveTask(task) {
    const authService = AuthService.getInstance();

    return task.taskId === -1
      ? authService.CallBackendFunctionPost('/api/Task', this.ConvertTaskToJSON(task))
      : authService.CallBackendFunctionPut(`/api/Task/${task.taskId}`, this.ConvertTaskToJSON(task));
  }

  static ExportTaskVsJobTitleReport() {
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost('/api/ExcelDataExport/CreateTaskVsJobTitleReport');
  }

  static ConvertTaskToJSON(task) {
    const taskJson = {
      name: task.name,
      isActive: this.toBoolean(task.isActive),
      isLeadMandatory: this.toBoolean(task.isLeadMandatory),
      isClientMandatory: this.toBoolean(task.isClientMandatory),
      isOpportunityMandatory: this.toBoolean(task.isOpportunityMandatory),
      isProjectMandatory: this.toBoolean(task.isProjectMandatory),
      isTpProjectMandatory: this.toBoolean(task.isTpProjectMandatory),
      isCommentMandatory: this.toBoolean(task.isCommentMandatory),
      taskOfficialJobTitles: [],
    };

    for (const taskOfficialJobTitle of task.taskOfficialJobTitles) {
      taskJson['taskOfficialJobTitles'].push({ officialJobTitleValue: taskOfficialJobTitle.officialJobTitleValue });
    }

    return taskJson;
  }

  static toBoolean(value) {
    return value === 0 || value === false ? false : true;
  }
}

export default TaskService;
